import { AgreementView } from 'containers/agreement/views';
import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

import { useAgreements } from './hooks';

export const AgreementContainer = () => {
  const { activeIndex, agreements, loading, submitLoading, onAccept } =
    useAgreements();

  const { t } = useTranslation();

  usePageTitle(t('containers.agreement.pageTitle'));

  return (
    <AgreementView
      activeIndex={activeIndex}
      agreements={agreements}
      loading={loading}
      submitLoading={submitLoading}
      onAccept={onAccept}
    />
  );
};
